import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { SessionManager } from './core/services/auth/session-manager/session-manager.service'
import { AuthInterceptor } from './core/interceptors/auth.interceptor'
import { GlobalModalComponent } from './core/components/layouts/global-modal/global-modal.component'

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, BrowserAnimationsModule, HttpClientModule, GlobalModalComponent],
  providers: [
    SessionManager,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule { }
